import React, { useEffect, useState,useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { END_URL, IMG_URL } from "../../config.js";
import BlogSideBar from '../BlogSideBar/BlogSideBar'; 
import "./BlogDetail.css"
import { slugify } from '../../utils/slugify';
import loadimg from "../../images/loader_wish.gif";
import { Helmet } from 'react-helmet';

const BlogDetail = ({token,userdetail,onLoginChange}) => {

  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [topics, setTopics] = useState([]); 
  const [selectedTopicId, setSelectedTopicId] = useState(null);

  const [selectedTopicAdd, setselectedTopicAdd] = useState(null); 

  const [selectedTopicLink, setselectedTopicLink] = useState(null);

  const [loading, setLoading] = useState(true);

  const [TestLink,setTestLink] = useState(null);

  const [TestLink1,setTestLink1] = useState(null);

const { slug } = useParams();

const [seo, setSeo] = useState({});

 const rowRef = useRef(null);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" }); 
  }, [slug]);

  useEffect(() => {
    if (!loading && blog) {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
      }, 0);
    }
  }, [loading, blog]);


useEffect(() => {
  
  const fetchBlog = async () => {

    try {
      const res = await axios.get(`${END_URL}/blog/${slug}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
      );
      const allTopics = res.data.topics;
      setTopics(allTopics);

      const seoDate = res.data.seo_page; 

      setSeo(seoDate);

      setTestLink1(res?.data?.topic_link?.slug);

      let found = null;
      let foundTopicId = null;

      let foundTopicAdver = null;

      let topic_link = null;

      for (const topic of allTopics) {
        const match = topic.blog.find(
          (b) => slugify(b.title) === slug
        );
        if (match) {
          found = match;
          foundTopicId = topic.id;

          foundTopicAdver =  topic.topic_adver;

          topic_link = topic.topic_link;
          break;
        }
      }

      setBlog(found);

      setselectedTopicLink(topic_link);

      setSelectedTopicId(foundTopicId);

      setselectedTopicAdd(foundTopicAdver);

    } catch (err) {
      console.error("Error fetching blog:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchBlog();
}, [slug]);

if (loading) {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        width: "100vw",
        height: "100vh",
      }}
    ></div>
  );
}

  if (!blog) return <div>Blog not found</div>;

  return (

    <>

     <Helmet>
    
            <title>{seo?.meta_title || 'PersonalityTest - Discover Your True Archetype | Personality Peek'}</title>

            <meta name="description" content={seo?.meta_description || 'Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey.'} />

            <meta name="keywords" content={seo?.meta_keywords || 'personality assessment test , personality test'} />
            
            {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
            {seo?.og_description && <meta property="og:description" content={seo.og_description} />}
            {seo?.og_image && <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />}
            {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
            {seo?.og_type && <meta property="og:type" content={seo.og_type} />}

            {seo?.twitter_title && <meta name="twitter:title" content={seo.twitter_title} />}
            {seo?.twitter_description && <meta name="twitter:description" content={seo.twitter_description} />}
            {seo?.twitter_image && <meta name="twitter:image" content={`${IMG_URL}/d0/${seo.twitter_image}`} />}
            {seo?.twitter_card && <meta name="twitter:card" content={seo.twitter_card} />}

            {seo?.og_url && <link rel="canonical" href={seo.og_url} />}

            {!seo?.og_title && <meta property="og:title" content="PersonalityTest - Discover Your True Archetype | Personality Peek" />}
            {!seo?.og_description && <meta property="og:description" content="Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey." />}
            {!seo?.og_type && <meta property="og:type" content="website" />}
            {!seo?.twitter_card && <meta name="twitter:card" content="summary_large_image" />}

    </Helmet>
    
      <div className='bl-det'  >
        <div className="container">
          <div className="row bl-det-row" ref={rowRef} >
            <div className="col-12 col-sm-12 col-md-8">
              <div className="bt-det-cover"> 
                <h1>{blog.title}</h1>
                <div>
                <span>Author: {blog.name || "Unknown Author"}</span>

                  <span>{blog.date ? new Date(blog.date).toLocaleDateString() : ""}</span>
                </div>
                <img src={`${IMG_URL}/d0/${blog.image}`} alt={blog.title} />
              
              <p dangerouslySetInnerHTML={{ __html: blog.content || "<p>No content available.</p>" }} ></p>
              </div>
            </div>
            <BlogSideBar
              topics={topics}
              selectedTopicId={selectedTopicId}
              setSelectedTopicId={setSelectedTopicId}
              selectedTopicAdd={selectedTopicAdd}
              selectedTopicLink={selectedTopicLink}
              token={token}
              userdetail={userdetail}
              onLoginChange={onLoginChange}
              TestLink={TestLink}
              TestLink1={TestLink1}
            />
          </div>
        </div>
      </div>
  </>

  );
};

export default BlogDetail;
